"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperAdminFolder = void 0;
const storage_file_service_1 = require("./storage-file.service");
const storage_base_service_1 = require("./storage-base.service");
class SuperAdminFolder extends storage_base_service_1.StorageBase {
    constructor(parent) {
        super(parent, 'super-admin');
    }
    files() {
        return {
            gamesUploadSample: new storage_file_service_1.StorageFile(this.root, 'games-upload-sample.csv'),
        };
    }
}
exports.SuperAdminFolder = SuperAdminFolder;
